<template lang="pug">
div
  dominacao-imovel(
    :required="true",
    :imovel="cadastro.imovel"
  )
  matricula-titulo-imovel(
    :imovel="cadastro.imovel"
    titulo="Dados do registro"
  )
  app-documentos(
    :maxSize='25000',
    :valid-extensions="['pdf','rar', 'zip']",
    :documentos="cadastro.imovel.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorios"
    :observer="observer",
    aba="Imóvel",
    validateRule='documentosObrigatorios'
  )
</template>

<script>
import AppDocumentos from '../../../../components/cadastro/AppDocumentos'
import { mapActions } from 'vuex'
import DominacaoImovel from '@/screens/central/cadastros/maranhao/processoFisico/components/DominacaoImovel'
import MatriculaTituloImovel from '@/screens/central/cadastros/maranhao/processoFisico/components/MatriculaTituloImovel'

export default {
  components: {
    DominacaoImovel,
    MatriculaTituloImovel,
    AppDocumentos
  },

  props: ['cadastro', 'observer'],

  async beforeRouteLeave (to, from, next) {
    await this.setDocumentosInteressado()
    await this.observer.validate({ providerName: 'Imóvel/Documentos', skipIfEmpty: false })
    next()
  },

  data () {
    return {
      documentos: [],
      documentosObrigatorios: []
    }
  },

  async created () {
    await this.setDocumentosInteressado()
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    async setDocumentosInteressado () {
      this.documentos = await this.findDocumentos(`processoFisico`)
      this.documentosObrigatorios = this.documentos.filter(documento => {
        return !['OUTROS_IMOVEL'].includes(documento.codigo)
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/processoFisico/components/Imovel.vue